import { render, staticRenderFns } from "./canada-performance-and-portfolio-distributions-table.vue?vue&type=template&id=0e65d9db&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports